<script setup>
	import { useRoute } from 'vue-router'
	import { ref, onMounted } from 'vue'
	import axios from 'axios'
	import Loading from '@/components/Loading.vue'

	const route = useRoute()
	const establishment_id = route.params.establishment_id || ''
	const order_id = route.params.order_id || ''

	const order = ref()
	const isEmpty = ref(false) 

	const getItemTotalCost = (item) => {
		return `$${(item.qty * item.price).toFixed(2)}`
	}

	const getOrderTotalCost = () => {
		return `$${order.value.orderItems.reduce((q, item) => q + (item.qty * item.price), 0)}`
	}

	onMounted(async () => {
		const { data } = await axios.get(`${establishment_id}/orders/${order_id}`)
		order.value = data
		isEmpty.value = order.value.orderItems.length === 0;
	})

</script>
<template>
	<div class="w-full h-screen flex items-center justify-center px-6">
		<div v-if="order" class="bg-white dark:bg-zinc-700 mx-1 my-2 rounded-3xl grow shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 border border-zinc-200/50 dark:border-zinc-900/50 flex flex-col py-6">
			<div v-for="(item, index) in order.orderItems" :key="index" class="mx-6 mb-3">
				<div class="flex items-center p-2">
	        		<span class="px-2 grow">{{ item.qty }} {{ item.name }}</span>
	        		<span class="shrink-0 ps-2">{{ getItemTotalCost(item) }}</span>
	        	</div>
	        	<hr class="dark:border-zinc-900/50" />
	     	</div>
	     	<div class="flex items-center p-2 mx-6 mb-3 text-xl font-bold">
	    		<span class="px-2">Total</span>
	    		<span class="ms-auto mr-2">{{ getOrderTotalCost() }}</span>
	    	</div>
		</div>
		<Loading
	        v-else
	        :isEmpty="isEmpty"
	        title="Lo sentimos"
	        description="No hemos encontrado la orden solicitada."
	     />
	</div>
</template>

